"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersPermissions = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const table_1 = require("client/components/material/table");
const table_cell_1 = require("client/components/material/table/table-cell");
const table_row_1 = require("client/components/material/table/table-row");
const floating_page_1 = require("client/components/page/floating-page");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./users-permissions.less");
const throttle_debounce_1 = require("throttle-debounce");
//E-048
const store_2 = require("../users-list/store");
const react_select_1 = require("react-select");
const modal_1 = require("client/components/modal");
const columns = [
    {
        center: false,
        // id: "user.something",
        id: "display",
        numeric: false,
        label: "Description"
    },
    {
        center: false,
        id: "category",
        numeric: false,
        label: "category"
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Manager",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "User",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Clinic Admin",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Clinic Manager",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Clinic Provider",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Clinic User",
        sortable: false
    },
    {
        center: false,
        id: "user.something",
        numeric: false,
        label: "Dist Admin"
    },
    {
        center: false,
        id: "user.something",
        numeric: false,
        label: "Dist Manager"
    },
    {
        center: false,
        id: "user.something",
        numeric: false,
        label: "Dist User"
    }
];
let UsersPermissions = class UsersPermissions extends react_1.Component {
    constructor() {
        super(...arguments);
        this.checkedBoxes = {};
        this.permissions = [];
        this.order = "ASC";
        this.orderBy = "category"; //C-065 replace to display to category
        //E-048
        this.autoLogOutTimeArray = [];
        this.state = {
            open: false
        };
        this.loadAllPermissions1 = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 1000,
                order: this.order,
                start: 0,
                where: "",
                sort: this.orderBy
            };
            store_1.usersStore.loadAllPermissions(options);
        });
        //E-048 Add didUpdate
        this.componentDidUpdate = async (prevProps, prevState) => {
            var _a;
            if (prevState.open !== this.state.open) {
                await store_2.usersListStore.loadGroups();
                this.autoLogOutTimeArray = (_a = store_2.usersListStore === null || store_2.usersListStore === void 0 ? void 0 : store_2.usersListStore.groups) === null || _a === void 0 ? void 0 : _a.value.filter((userAdmin => (userAdmin === null || userAdmin === void 0 ? void 0 : userAdmin.name) != "admin"));
            }
        };
        this.loadAll = async () => {
            const options = {
                count: 1000,
                order: this.order,
                start: 0,
                where: "",
                sort: this.orderBy
            };
            this.permissions = await store_1.usersStore.loadAllPermissions(options);
        };
        this.onHandleUpdatePermissions = async () => {
            await store_1.usersStore.updatePermissions(this.permissions);
            this.loadAll();
        };
        // add fuction for Auto logOUT  after inactivity time
        //E-048
        this.handleClickForAutoLogOutTime = async () => {
            await store_1.usersStore.updateAutoLogoutTime(this.autoLogOutTimeArray);
            this.setState({ open: !this.state.open });
        };
        //E-048
        this.HandleTimeAutoLogOut = () => {
            this.setState({ open: true });
        };
        this.handleModalClose = () => {
            this.autoLogOutTimeArray = store_2.usersListStore.groups.value;
            this.setState({ open: !this.state.open });
        };
        //E-048.2
        this.handleAutoLogoutTime = (value) => {
            this.autoLogOutTimeArray.map((group, i) => {
                if (group.id === value.name.group.id) {
                    let array = this.autoLogOutTimeArray;
                    array[i].auto_logout_time = parseInt(value.value);
                    this.autoLogOutTimeArray = array;
                }
            });
        };
        this.onRequestSort = (property) => {
            console.log("property", property);
            console.log("order", this.order);
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            console.log(this.permissions, "this.permissions");
            this.loadAll();
            this.loadAllPermissions1();
        };
        this.handleCheckGroup = (row, index, user) => {
            const value = this.permissions[index][user];
            // console.log(this.permissions[index], this.permissions[index][user]);
            this.permissions[index][user] = value ? 0 : 1;
        };
        this.renderTableRow = (row, index) => (React.createElement(table_row_1.MaterialTableRow, { key: index, to: `` },
            React.createElement(table_cell_1.MaterialTableCell, { header: true },
                React.createElement("b", null, row.display),
                row.display === "Auto Log Out User" && (React.createElement(button_1.MaterialButton
                // className="users__save-btn"
                // primary
                , { 
                    // className="users__save-btn"
                    // primary
                    onClick: () => this.HandleTimeAutoLogOut() }, "Time"))),
            React.createElement(table_cell_1.MaterialTableCell, { header: true },
                React.createElement("b", null, row.category)),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].manager, label: "Manager", onAction: () => this.handleCheckGroup(row, index, "manager") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].user, label: "User", onAction: () => this.handleCheckGroup(row, index, "user") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].siteAdmin, label: "Clinic Admin", onAction: () => this.handleCheckGroup(row, index, "siteAdmin") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].siteManager, label: "Clinic Manager", onAction: () => this.handleCheckGroup(row, index, "siteManager") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].siteProvider, label: "Clinic Provider", onAction: () => this.handleCheckGroup(row, index, "siteProvider") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].siteUser, label: "Clinic User", onAction: () => this.handleCheckGroup(row, index, "siteUser") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].distAdmin, label: "Dist Admin", onAction: () => this.handleCheckGroup(row, index, "distAdmin") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].distManager, label: "Dist Manager", onAction: () => this.handleCheckGroup(row, index, "distManager") })),
            React.createElement(table_cell_1.MaterialTableCell, { center: true },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.permissions[index].distUser, label: "Dist User", onAction: () => this.handleCheckGroup(row, index, "distUser") }))));
    }
    async componentDidMount() {
        await this.loadAll();
    }
    //E-048
    render() {
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleModalClose }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleClickForAutoLogOutTime, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", { className: "users" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "users__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "User Permissions" }))),
            React.createElement(floating_page_1.FloatingPage, null, this.renderInfo()),
            this.state.open ? (React.createElement(modal_1.Modal, { onCancel: this.handleModalClose, height: "fit-content", top: "25%", width: "fit-content", buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { className: "", style: { width: "65vw", maxWidth: "90vw" } },
                        React.createElement("div", { style: { display: "flex" } }, this.autoLogOutTimeArray.sort((a, b) => a.priority - b.priority).map((group) => (React.createElement("div", { className: `select imbfee-select` },
                            React.createElement("div", { className: "select__label", style: { textTransform: "capitalize" } },
                                group.name,
                                " "),
                            React.createElement(react_select_1.default
                            // openOnFocus={true}
                            , { 
                                // openOnFocus={true}
                                value: group.auto_logout_time.toString() || "", onChange: this.handleAutoLogoutTime, options: [
                                    {
                                        id: 1,
                                        label: "5 min",
                                        value: "5",
                                        name: { group }
                                    },
                                    {
                                        id: 2,
                                        label: "10 min",
                                        value: "10",
                                        name: { group }
                                    },
                                    {
                                        id: 3,
                                        label: "15 min",
                                        value: "15",
                                        name: { group }
                                    },
                                    {
                                        id: 4,
                                        label: "30 min",
                                        value: "30",
                                        name: { group }
                                    },
                                    {
                                        id: 5,
                                        label: "45 min",
                                        value: "45",
                                        name: { group }
                                    },
                                    {
                                        id: 6,
                                        label: "1 Hour",
                                        value: "60",
                                        name: { group }
                                    },
                                    {
                                        id: 7,
                                        label: "2 Hours",
                                        value: "120",
                                        name: { group }
                                    },
                                    {
                                        id: 8,
                                        label: "4 Hours",
                                        value: "240",
                                        name: { group }
                                    },
                                    {
                                        id: 9,
                                        label: "8 Hours",
                                        value: "480",
                                        name: { group }
                                    },
                                ] })))))),
                    React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginTop: "12rem" } }))) //E-048.2
            ) : null));
    }
    renderInfo() {
        console.log("rerender");
        return (React.createElement("div", { className: "users__main" },
            "TMP Admins automatically have all of these options enabled.",
            React.createElement("div", { className: "users__data" },
                React.createElement(table_1.MaterialTable, { clickable: true, noMargin: true, columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: this.permissions || [], renderRow: this.renderTableRow }),
                React.createElement(button_1.MaterialButton, { className: "users__save-btn", primary: true, onClick: () => this.onHandleUpdatePermissions() }, "Save"))));
    }
};
__decorate([
    mobx_1.observable
], UsersPermissions.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], UsersPermissions.prototype, "permissions", void 0);
__decorate([
    mobx_1.observable
], UsersPermissions.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], UsersPermissions.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], UsersPermissions.prototype, "autoLogOutTimeArray", void 0);
UsersPermissions = __decorate([
    mobx_react_1.observer
], UsersPermissions);
exports.UsersPermissions = UsersPermissions;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/modules/users-permissions/users-permissions.tsx
// module id = 4155
// module chunks = 0